import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransferenciaCreditoClienteJanelaRoutingModule } from './transferencia-credito-cliente-janela-routing.module';
import { TransferenciaCreditoClienteJanelaComponent } from './transferencia-credito-cliente-janela.component';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    TransferenciaCreditoClienteJanelaComponent
  ],
  imports: [
    CommonModule,
    TransferenciaCreditoClienteJanelaRoutingModule,
    MessagesModule,
    ProgressSpinnerModule
  ]
})
export class TransferenciaCreditoClienteJanelaModule { }
